import { useLocation } from 'react-router-dom'
import type { Crumb } from '@/components/ui'

/**
 * El portal del cliente y el panel del partner comparten paginas —Facturas,
 * Proyectos, Cotizaciones, Mi perfil son el MISMO componente montado en dos
 * rutas— y lo unico que las distingue es la URL. De ahi se deriva el inicio al
 * que vuelven los breadcrumbs: un `/portal` fijo dentro del panel del partner
 * es un enlace que el guard rebota al login, porque ese usuario no es cliente.
 *
 * Mismo criterio que ya usaba ProyectosIndex para armar los enlaces de fila.
 */
export function usePanelBase(): '/portal' | '/partner' {
  return useLocation().pathname.startsWith('/partner') ? '/partner' : '/portal'
}

/**
 * Primer crumb de una pagina compartida: el grupo del menu donde esta montada.
 *
 * En el panel del partner no alcanza con un valor fijo: las mismas paginas
 * cuelgan de grupos distintos —Proyectos esta en Operaciones y Facturas en
 * Afiliados— y un crumb que dijera siempre lo mismo contradiria al menu que el
 * usuario tiene a la izquierda.
 */
export function useCrumbInicio(): Crumb {
  const { pathname } = useLocation()
  if (!pathname.startsWith('/partner')) return { label: 'Portal', to: '/portal' }
  if (pathname.startsWith('/partner/proyectos')) return { label: 'Operaciones', to: '/partner/proyectos' }
  return { label: 'Afiliados', to: '/partner/mi-cuenta' }
}
